import { useCallback, useMemo } from 'react';
import { FilterValues } from '../types';
import { useDrawerContext } from '../context';

type UseDrawerFiltersResult = {
  retainedFilters: FilterValues;
  handleDrawerRateinedFiltersChange: (newRateinedFilters: FilterValues) => void;
};

export const useDrawerFilters = (): UseDrawerFiltersResult => {
  const { retainedFilters, setRetainedFilters } = useDrawerContext();

  const handleDrawerRateinedFiltersChange = useCallback((newRateinedFilters: FilterValues): void => {
    setRetainedFilters(newRateinedFilters);
  }, []);

  return useMemo(
    () => ({
      retainedFilters,
      handleDrawerRateinedFiltersChange,
    }),
    [retainedFilters, handleDrawerRateinedFiltersChange]
  );
};

export default useDrawerFilters;
